var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTorq(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Property 1=Torq, Size=16"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.69551 0.5H14.9033C15.7797 0.5 16.4902 1.21051 16.4902 2.08697V3.89078H7.69551V0.5Z",
    fill: "#00A5C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.49685 15.6946H2.07721C1.20075 15.6946 0.490234 14.9841 0.490234 14.1076V12.3038H9.49685V15.6946Z",
    fill: "#00A5C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.490235 6.39142H16.4902V9.88814H0.490235V6.39142Z",
    fill: "#00A5C3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTorq);
export default __webpack_public_path__ + "static/media/Torq.c974abfa8e7482457496c91e1ef9d911.svg";
export { ForwardRef as ReactComponent };